// extracted by mini-css-extract-plugin
export var resizer = "_h4-0";